/**
 * Hook de datos del **selector de sede**: lista las sedes disponibles.
 *
 * Solo tiene sentido para usuarios multi-sede (el backend reserva `GET /sedes`
 * al permiso `all`), por eso se habilita con `enabled`. Datos de servidor →
 * TanStack Query (`docs/frontend_conventions.md`).
 */
import { useQuery } from "@tanstack/react-query";

import { fetchSedes, type SedeOption } from "../sedesApi";

/** Query key del catálogo de sedes para el selector. */
export const SEDES_QUERY_KEY = ["sedes", "options"] as const;

export function useSedes(enabled: boolean) {
  return useQuery<SedeOption[]>({
    queryKey: SEDES_QUERY_KEY,
    queryFn: fetchSedes,
    enabled,
    staleTime: 5 * 60_000,
  });
}
